import { render, staticRenderFns } from "./PageArticles.vue?vue&type=template&id=092481b4"
import script from "./PageArticles.vue?vue&type=script&lang=js"
export * from "./PageArticles.vue?vue&type=script&lang=js"
import style0 from "./PageArticles.vue?vue&type=style&index=0&id=092481b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports